import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  carusel_container: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "74px",
  },

  slider_container: {
    textAlign: "center",
    height: "62vh",
    outline: "none",
    "& img": {
      width: "95%",
      height: "100%",
      margin: "auto",
      objectFit: "cover",
    },
  },

  slidePictureSmallScreen: {
    textAlign: "center",
    height: "55vh",
    outline: "none",
    "& img": {
      width: "86%",
      height: "96%",
      margin: "auto",
      objectFit: "cover",
    },
  },

  carusel_title: {
    marginTop: "100px",
    textAlign: "center",
    fontSize: "35px",
    fontWeight: 400,
  },

  carusel_description: {
    textAlign: "center",
    padding: "0px 20px",
    fontWeight: "normal",
    width: "60%",
    margin: "auto",
    marginBottom: "20px",
  },
}));

export default useStyles;
